import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { CVDTable } from "./CVDTable";

export const CVD = withRouter(
  withApollo((props) => {
    const [filterparams, setFilterparams] = useState({});

    function onSearch(searchtext) {
      setFilterparams({
        ...filterparams,
        searchtext,
      });
    }

    return (
      <Grid container spacing={2}>
        <Grid container item xs={12} sm={12} alignItems={"flex-end"}>
          <Grid item xs={6} sm={6}>
            <Typography component="h6" variant="h6">
              CVD Diamond Comparison
            </Typography>
          </Grid>
        </Grid>
        <CVDTable filterparams={filterparams} history={props.history} />
      </Grid>
    );
  })
);

export default CVD;
